import { memo } from 'react';
import { NodeProps, Handle, Position } from 'reactflow';
import { palette } from '../../lib/palette';
import { BaseNode } from './BaseNode';

/** Bloco IA: conversa com o contato; sai por "Resolvido" ou "Atendente" */
const OUTPUTS = [
  { id: 'main', label: 'Resolvido', color: palette.green.dark1 },
  { id: 'handoff', label: 'Atendente', color: palette.yellow.dark2 },
];

export const AINode = memo((props: NodeProps) => {
  const config = props.data.config || {};
  const instructions: string = config.instructions || config.prompt || '';
  const description = instructions
    ? `${instructions.substring(0, 34)}${instructions.length > 34 ? '…' : ''}`
    : 'Configure o atendente';

  return (
    <BaseNode
      {...props}
      description={description}
      onDelete={props.data.onDelete}
      sourceHandles={
        <>
          <div style={{ display: 'flex', borderTop: `1px solid ${palette.gray.light2}` }}>
            {OUTPUTS.map((o) => (
              <div key={o.id} style={{ flex: 1, padding: '6px 4px 8px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, fontSize: 11, fontWeight: 500, color: palette.gray.dark2 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: o.color }} />
                {o.label}
              </div>
            ))}
          </div>
          {OUTPUTS.map((o, i) => (
            <Handle key={o.id} type="source" position={Position.Bottom} id={o.id} title={o.label}
              style={{ width: 10, height: 10, background: o.color, border: '2px solid var(--surface)', left: `${25 + i * 50}%` }} />
          ))}
        </>
      }
    />
  );
});

AINode.displayName = 'AINode';
